import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import { QuizContentService } from "../../services/quiz-content.service";
import Quiz, { QuizAnswer } from "../../models/quiz.model";
import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { UUID } from "angular2-uuid";
import { Subject } from "rxjs";

@Component({
  selector: "ngx-dialog-quiz-content",
  templateUrl: "dialog-quiz-content.component.html",
  styleUrls: ["dialog-quiz-content.component.scss"],
})
export class DialogQuizContentComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() title: string;
  @Input() description?: string;
  @Input() quizId?: string;

  quiz: Quiz = new Quiz();
  sourceBackup: Quiz = new Quiz();
  trees?: Set<string> = new Set([]);

  isEditSource = false;
  isContentChanged = false;

  diaForm: FormGroup;
  submitted = false;
  loading = false;

  type?: string; //text,image,document,video
  value: string;
  content: string;
  isCorrect?: boolean;
  errMessage: string = "";

  @ViewChild("questionTitle", { static: false }) questionTitle: ElementRef;
  @ViewChild("answerContent", { static: false }) answerContent: ElementRef;

  constructor(
    protected ref: NbDialogRef<DialogQuizContentComponent>,
    private fb: FormBuilder,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService,
    private quizService: QuizContentService
  ) {}

  ngOnInit() {
    const titleValidators = [
      Validators.minLength(3),
      Validators.maxLength(250),
      Validators.required,
    ];
    this.diaForm = this.fb.group({
      title: ["", titleValidators],
      type: ["", Validators.required],
    });

    this.type = "text";
    this.content = "";
    this.value = "";

    if (this.quizId && this.quizId != "") {
      this.getQuiz(this.quizId);
    } else {
      this.trees.add("QA");
      this.quiz.type = "radio";
      this.quiz.valueAnswer = "";
      this.quiz.answers = [];
    }

    if (!this.quiz.question) {
      this.quiz.question = "";
    }
    if (!this.quiz.explain) {
      this.quiz.explain = "";
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => this.questionTitle.nativeElement.focus());
  }

  getQuiz(id: string): void {
    this.loading = true;
    this.quizService.getQuizById(id).then((doc) => {
      if (doc.exists) {
        this.loading = false;
        this.quiz = doc.data();
        this.quiz.id = id;

        var trees = new Set([]);
        if (this.quiz.tags && this.quiz.tags.length > 0) {
          this.quiz.tags.forEach(function (value) {
            trees.add(value);
          });
        }
        this.trees = trees;

        this.sourceBackup = { ...this.quiz };
      }
    });
  }

  close() {
    if (this.isContentChanged) {
      this.ref.close(this.quiz);
    } else {
      this.ref.close();
    }
  }

  submit() {
    this.submitted = true;
    this.errMessage = "";

    if (this.quiz.type === "document") {
      this.quiz.valueAnswer = "";
      this.quiz.resultAnswers = [];
      this.quiz.answers = [];
    } else if (this.quiz.type === "input") {
      this.quiz.resultAnswers = [];
      this.quiz.answers = [];
      if (this.quiz.valueAnswer === "") {
        this.errMessage = "Câu hỏi này phải nhập đáp án đúng.";
      }
    } else {
      //type: radio /check
      this.quiz.valueAnswer = "";
      this.quiz.resultAnswers = [];
      let noCorrect = 0;
      this.quiz.answers.forEach((item) => {
        if (item.isCorrect) {
          noCorrect++;
          this.quiz.resultAnswers.push(item.value);
        }
      });

      const noIncorrect = this.quiz.answers.length - noCorrect;

      if (this.quiz.type === "radio" && (noCorrect != 1 || noIncorrect == 0)) {
        this.errMessage =
          "Câu hỏi trắc nghiệm phải có 01 đáp án đúng và [tối thiểu] 01 đáp án sai.";
      } else if (
        this.quiz.type === "check" &&
        (noCorrect == 0 || noIncorrect == 0)
      ) {
        this.errMessage =
          "Câu hỏi chọn 1 hoặc nhiều thì phải có [tối thiểu] 01 đáp án đúng và 01 đáp án sai.";
      }
    }

    var tags: string[] = [];
    this.trees.forEach(function (item) {
      tags.push(item);
    });
    this.quiz.tags = tags;

    if (this.errMessage.length == 0) {
      this.isEditSource ? this.updateQuiz() : this.createQuiz();
    } else {
      this.submitted = false;
    }

    // if (this.isEditSource) {
    //   this.updateQuiz();
    // } else {
    //   this.createQuiz();
    // }
  }

  private createQuiz() {
    this.loading = true;
    this.submitted = true;

    this.quizService
      .create(this.quiz)
      .then((result) => {
        this.quiz.id = result;

        this.loading = false;
        this.submitted = false;
        this.isContentChanged = true;
        this.isEditSource = true;
        this.showToast("success", "Câu hỏi", "Thêm mới thành công");
        this.close();
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
        this.showToast("warning", "Câu hỏi", "Thêm mới thất bài");
      });
  }

  private updateQuiz() {
    this.loading = true;
    this.submitted = true;
    this.quizService
      .update(this.quiz)
      .then((result) => {
        this.loading = false;
        this.submitted = false;
        this.isContentChanged = true;
        this.showToast("success", "Câu hỏi", "Cập nhật thành công");
        this.sourceBackup = { ...this.quiz };
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
        this.showToast("warning", "Câu hỏi", "Cập nhật thất bài");
      });
  }

  //QuizAnswer
  uploadImage(imageURL: string) {
    if (imageURL) this.content = imageURL;
  }

  onAnswerTypeChange($event) {
    this.content = "";
  }

  addAnswer() {
    const ans = new QuizAnswer();
    ans.value = UUID.UUID();
    ans.isCorrect = this.isCorrect;
    ans.type = this.type;
    ans.content = this.content;
    this.quiz.answers.push(ans);

    this.type = "text";
    this.content = "";
    this.value = "";

    this.answerContent.nativeElement.focus();
  }

  removeAnswer(item) {
    const index = this.quiz.answers.indexOf(item);
    if (index > -1) {
      this.quiz.answers.splice(index, 1);
    }
  }

  // control event
  onTypeChange() {
    if (this.isEditSource && !this.loading) {
      this.dialogService
        .open(DialogYesNoPromptComponent, {
          context: {
            title: "Bạn có chắc muốn thay đổi phương thức nhập đáp án?",
            description:
              "Khi thay đổi thì toàn bộ dữ liệu đáp án sẽ bị xóa, để tạo lại từ đầu!",
          },
        })
        .onClose.subscribe((value) => {
          if (value) {
            this.quiz.valueAnswer = "";
            this.quiz.answers = [];
          } else {
            this.quiz.type = this.sourceBackup.type;
          }
        });
    }
  }

  //Tags
  onTagRemove(tagToRemove: NbTagComponent): void {
    this.trees.delete(tagToRemove.text);
  }

  onTagAdd({ value, input }: NbTagInputAddEvent): void {
    if (value) {
      this.trees.add(value.trim().toUpperCase());
    }
    input.nativeElement.value = "";
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
